'use client';

import { useLocale, useTranslations } from 'next-intl';
import { FEATURED_PROJECTS } from '@/lib/content/projects';
import { Button } from './common/Button';
import { ProjectCard } from './work/ProjectCard';
import './work/mockups/mockups.css';

const LAYOUT = [
  { slug: 'olingo-medical',         col: 'col-span-12',               variant: 'hero'     },
  { slug: 't-systems-connectivity', col: 'col-span-12 md:col-span-7', variant: 'wide'     },
  { slug: 'rowanai',                col: 'col-span-12 md:col-span-5', variant: 'standard' },
  { slug: 'eurowag-legislation',    col: 'col-span-12',               variant: 'hero-rev' },
] as const;

const BY_SLUG = Object.fromEntries(FEATURED_PROJECTS.map((p) => [p.slug, p]));

export function FeaturedProjects() {
  const t = useTranslations('featuredProjects');
  const tWork = useTranslations('work');
  const locale = useLocale();
  const benefits = t.raw('benefits') as Record<string, string>;
  const results = t.raw('results') as Record<string, string>;

  function deployLabel(deployment: string) {
    if (deployment === 'on-premise')    return tWork('deployment_on_premise');
    if (deployment === 'private-cloud') return tWork('deployment_private_cloud');
    return tWork('deployment_hybrid');
  }

  return (
    <section className="cv-auto bg-stats-bg py-20 px-[10%]">
      <div className="max-w-8xl mx-auto flex flex-col gap-10">

        {/* Header */}
        <div className="flex flex-col gap-3">
          <p className="font-mono text-eyebrow font-semibold tracking-[var(--hero-label-tracking)] uppercase text-font-navy">
            {t('eyebrow')}
          </p>
          <h2 className="text-[length:var(--text-section-title)] font-normal tracking-[-0.02em] leading-[1.1] text-font-secondary">
            {t('title_line1')}<br />{t('title_line2')}
          </h2>
        </div>

        {/* Project grid — Karten laufen unten gewollt hinter einem Fade aus,
            der einzelne CTA sitzt scharf darüber. */}
        <div className="relative">
          <div className="grid grid-cols-12 gap-[clamp(18px,1.6vw,26px)]">
            {LAYOUT.map((item) => {
              const project = BY_SLUG[item.slug];
              if (!project) return null;
              return (
                <div key={item.slug} className={item.col}>
                  <ProjectCard
                    project={project}
                    locale={locale}
                    variant={item.variant}
                    deployText={deployLabel(project.deployment)}
                    benefit={benefits[project.slug]}
                    result={results[project.slug]}
                  />
                </div>
              );
            })}
          </div>

          {/* gewollter Fade in die Sektionsfläche */}
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-[260px] bg-gradient-to-b from-transparent to-[var(--stats-bg)]" />

          {/* Button scharf über dem Fade */}
          <div className="absolute inset-x-0 bottom-5 flex justify-center">
            <Button variant="dark" text={t('cta')} url={`/${locale}/work`} />
          </div>
        </div>
      </div>
    </section>
  );
}
